<template>
    <v-container fluid>
        <v-progress-circular indeterminate v-bind:size="70" v-bind:width="7" class="purple--text"></v-progress-circular>

        <h1>Login callback ...</h1>
    </v-container>

</template>

<script>
    export default {
        name: 'callback',
        data() {
            return {
                title: 'Login callback',
            };
        },
        created() {
            this.$store.dispatch('auth/LOGIN')
                .then((redirect) => {
                    this.$log.info(`Callback redirect to ${redirect}`);
                    this.$router.replace({ path: redirect });
                })
                .catch(error => this.$store.commit('errors/ADD', error, { root: true }));
        },
    };
</script>



// WEBPACK FOOTER //
// Callback.vue?6ad4d793